module.exports = __webpack_public_path__ + "static/family-7e98e7dc2ba68aae4504e4db6dd74e09.jpg";